import React, { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const PersonalInfoPage = () => {
  useEffect(() => {
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "個人情報の取り扱いについて | TOUAREG GLOBAL",
      "description": "株式会社ミションの個人情報の取り扱いについて。お客様の個人情報保護に関する方針を詳しく説明しています。",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/personal-info`,
      "isPartOf": {
        "@type": "WebSite",
        "name": "TOUAREG GLOBAL",
        "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
      },
      "publisher": {
        "@type": "Organization",
        "name": "株式会社ミション"
      },
      "dateModified": "2025-01-01",
      "inLanguage": "ja"
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-16">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-gray-900 mb-8 text-center">
              個人情報の取り扱いについて
            </h1>
            
            <div className="bg-white rounded-xl shadow-lg p-8 space-y-8">
              <div>
                <p className="text-gray-600 mb-6">
                  株式会社ミション（以下「当社」といいます。）は、お客様からお預かりする個人情報の重要性を深く認識し、個人情報保護法その他の関連法令を遵守し、以下の方針に基づいて個人情報を適切に取り扱います。
                </p>
              </div>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. 個人情報の収集について</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  当社は、以下の目的のために必要な範囲で個人情報を収集いたします：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>投資・資産管理サービスの提供</li>
                  <li>お客様からのお問い合わせへの対応</li>
                  <li>サービスに関する重要なお知らせの送付</li>
                  <li>新サービスや商品のご案内</li>
                  <li>セミナーやイベントのご案内</li>
                  <li>アフターサービス、メンテナンスのご案内</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. 収集する個人情報の種類</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  当社が収集する個人情報は以下の通りです：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>氏名、住所、電話番号、メールアドレス</li>
                  <li>生年月日、性別、職業</li>
                  <li>投資経験、資産状況、投資目的</li>
                  <li>取引履歴、口座情報</li>
                  <li>その他サービス提供に必要な情報</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. 個人情報の利用目的</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  収集した個人情報は、以下の目的で利用いたします：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>投資・資産管理サービスの提供および管理</li>
                  <li>お客様への連絡、情報提供</li>
                  <li>契約の履行、取引の実行</li>
                  <li>法令に基づく報告、届出</li>
                  <li>マーケティング活動、商品開発</li>
                  <li>リスク管理、内部管理</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. 個人情報の第三者提供</h2>
                <p className="text-gray-600 leading-relaxed mb-4">
                  当社は、以下の場合を除き、お客様の同意なく個人情報を第三者に提供することはありません：
                </p>
                <ul className="list-disc list-inside text-gray-600 space-y-2 ml-4">
                  <li>法令に基づく場合</li>
                  <li>人の生命、身体または財産の保護のために必要がある場合</li>
                  <li>公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合</li>
                  <li>国の機関もしくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行することに対して協力する必要がある場合</li>
                </ul>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. 個人情報の管理・保護</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、個人情報の漏洩、滅失または毀損の防止その他の個人情報の安全管理のために必要かつ適切な措置を講じます。また、個人情報を取り扱う従業員に対して必要かつ適切な監督を行います。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. 個人情報の開示・訂正・削除</h2>
                <p className="text-gray-600 leading-relaxed">
                  お客様は、当社が保有するご自身の個人情報について、開示、訂正、追加、削除、利用停止、消去および第三者提供の停止を求めることができます。これらのご請求については、ご本人確認の上、法令に従って対応いたします。
                </p>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. お問い合わせ窓口</h2>
                <div className="text-gray-600 leading-relaxed">
                  <p className="mb-4">
                    個人情報の取り扱いに関するお問い合わせは、以下までご連絡ください：
                  </p>
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="font-semibold text-gray-900 mb-3">株式会社ミション 個人情報保護窓口</h3>
                    <div className="space-y-2">
                      <p><strong>所在地：</strong>〒610-0121 京都府城陽市寺田北山田26-7-401</p>
                      <p><strong>電話番号：</strong>090-3677-1000</p>
                      <p><strong>メールアドレス：</strong>touaregglobal@gmail.com</p>
                      <p><strong>受付時間：</strong>平日 9:00-18:00</p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. 本方針の変更</h2>
                <p className="text-gray-600 leading-relaxed">
                  当社は、法令の変更や事業内容の変更等に伴い、本方針を変更することがあります。変更後の方針については、当社ウェブサイトに掲載することにより、お客様にお知らせいたします。
                </p>
              </section>

              <section>
                <div className="text-center pt-8 border-t border-gray-200">
                  <p className="text-gray-600">
                    制定日：2025年1月1日<br />
                    最終更新日：2025年1月1日
                  </p>
                  <p className="text-gray-900 font-semibold mt-4">
                    株式会社ミション<br />
                    代表取締役 福井秀延
                  </p>
                </div>
              </section>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PersonalInfoPage;